module.exports = {
      id: "bell-usage",
      viewBox: "0 0 20 22.857",
      url: "/" + "sprite-830c6fc89c6e575b53718d760c90aee8.svg#bell",
      toString: function () {
        return this.url;
      }
    }